/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GetMetricsGated } from './getMetricsGated';

export type GetMetricsParams = {
  /**
   * Inclusive range start (ISO datetime)
   */
  from?: string;
  /**
   * Exclusive range end (ISO datetime)
   */
  to?: string;
  gated?: GetMetricsGated;
  excludePasteHeavy?: boolean;
  excludeFirstTryPasses?: boolean;
  /**
   * Comma-separated metric names
   */
  metrics: string;
};
